module.exports = __webpack_public_path__ + "img/sq.7c6a9eed.png";